import { Button, Card, Col, Form, Input, Modal, Row, Select, Typography } from "antd";
import { toast } from "react-toastify";
import getSetting from "../../api/getSettings";

import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import Loader from "../loader/loader";
import styles from "./AddDetails.module.css";

const client_Id = getCompanyIdFromToken()

const AddDetails = ({ onUpdate }) => {
  const { Title } = Typography;
  const { Option } = Select;

  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [initValues, setInitValues] = useState([]);
  const [isAddingNewOffice, setIsAddingNewOffice] = useState(false);
  const [officeNames, setOfficeNames] = useState([]);
  const [companyTypes, setCompanyTypes] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOfficeType, setSelectedOfficeType] = useState(null);

  const companyId = getCompanyIdFromToken();

  const showModal = () => {
    setIsModalVisible(true);
  };

  // Handle modal close
  const handleCancel = () => {
    setIsModalVisible(false);
    modalForm.resetFields();
  };



  // const fetchSettings = async () => {
  //   try {
  //     const response = await getSetting();
  //     console.log("Fetched settings response:", response);
  //     if (response?.result?.length) {
  //       const officeNamesArray = response.result?.map(
  //         (setting) => setting.company_name || ""
  //       ).filter(Boolean);
  //       setInitValues(response.result);
  //       setOfficeNames(officeNamesArray);

  //       // Set the default office and its details
  //       const defaultOffice = officeNamesArray?.[0] || null;
  //       const defaultOfficeDetails = response.result?.find(
  //         (setting) => setting.company_name === defaultOffice
  //       ) || {};
  //       console.log("Default office details:", defaultOfficeDetails);

  //       if (defaultOfficeDetails) {
  //         console.log("call", defaultOfficeDetails?.officeTypeId);

  //         form.setFieldsValue({
  //           selectedOffice: defaultOffice || "",
  //           ...defaultOfficeDetails,
  //           officeTypeId: defaultOfficeDetails?.officeTypeId || null // Ensure officeTypeId is set
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching settings:", error);
  //     toast.error("Failed to fetch settings");
  //   }
  // };

  // const fetchSettings = async () => {
  //   try {
  //     const response = await getSetting();
  //     console.log("Fetched settings response:", response);
  //     if (response?.result?.length) {
  //       const officeNamesArray = response.result
  //         ?.map((setting) => setting.company_name || "")
  //         .filter(Boolean);
  //       setInitValues(response.result);
  //       setOfficeNames(officeNamesArray);

  //       const defaultOffice = officeNamesArray[0];
  //       const defaultOfficeDetails = response.result.find(
  //         (setting) => setting.company_name === defaultOffice
  //       ) || {};

  //       if (defaultOfficeDetails) {
  //         const initialFormValues = {
  //           selectedOffice: defaultOffice || "",
  //           ...defaultOfficeDetails,
  //           officeTypeId: defaultOfficeDetails.officeTypeId || null,
  //           phone: defaultOfficeDetails.phone?.replace("+44", "") || "",
  //         };
  //         console.log("Setting initial form values:", initialFormValues);
  //         form.setFieldsValue(initialFormValues);
  //         setSelectedOfficeType(defaultOfficeDetails.officeTypeId || null); // Sync state
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching settings:", error);
  //     toast.error("Failed to fetch settings");
  //   }
  // };
  const fetchSettings = async () => {
    try {
      const response = await getSetting();
      console.log("Fetched settings response:", response);
      if (response?.result?.length) {
        // const officeNamesArray = response.result
        //   ?.map((setting) => setting.company_name || "")
        //   .filter(Boolean);
        const officeNamesArray = response.result
          .filter(item => String(item.id) === String(companyId))
          .map(item => item.company_name)       // ← no empty‑string fallback
          .filter(Boolean);                     // remove undefined / empty

        setInitValues(response.result);
        setOfficeNames(officeNamesArray);

        // Get the currently selected office from the form
        const currentOffice = form.getFieldValue("selectedOffice") || officeNamesArray[0];
        const officeDetails = response.result.find(
          (setting) => setting.company_name === currentOffice
        ) || {};

        if (officeDetails) {
          const formValues = {
            selectedOffice: currentOffice || "",
            ...officeDetails,
            officeTypeId: officeDetails.officeTypeId || null,
            phone: officeDetails.phone?.replace("+44", "") || "",
          };
          // console.log("Setting form values after fetch:", formValues);
          form.setFieldsValue(formValues);
          // Sync with the form's latest officeTypeId
          const latestOfficeTypeId = form.getFieldValue("officeTypeId") || officeDetails.officeTypeId;
          setSelectedOfficeType(latestOfficeTypeId);
          // console.log("SelectedOfficeType set to:", latestOfficeTypeId);
        }
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
      toast.error("Failed to fetch settings");
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      setLoader(true);
      try {
        // Fetch office types first
        const typesResponse = await axios.get("setting/getOfficeTypes");
        if (typesResponse?.data?.length) {
          setCompanyTypes(typesResponse.data);
        } else {
          console.error("Invalid data received from getOfficeTypes API:", typesResponse);
        }

        const settingsResponse = await getSetting();
        if (settingsResponse?.result?.length) {
          // const officeNamesArray = settingsResponse.result
          //   ?.map((setting) => setting.company_name || "")
          //   .filter(Boolean);

          const officeNamesArray = settingsResponse.result
            .filter(item => String(item.id) === String(companyId))
            .map(item => item.company_name)
            .filter(Boolean);


          setInitValues(settingsResponse.result);
          setOfficeNames(officeNamesArray);

          const defaultOffice = officeNamesArray[0];
          const defaultOfficeDetails = settingsResponse.result.find(
            (setting) => setting.company_name === defaultOffice
          ) || {};

          if (defaultOfficeDetails) {
            const initialFormValues = {
              selectedOffice: defaultOffice || "",
              ...defaultOfficeDetails,
              officeTypeId: defaultOfficeDetails.officeTypeId || null,
              phone: defaultOfficeDetails.phone?.replace("+44", "") || "",
            };
            // console.log("Initial form values on load:", initialFormValues);
            form.setFieldsValue(initialFormValues);
            setSelectedOfficeType(defaultOfficeDetails.officeTypeId || null); // Sync state
          }
        } else {
          console.error("Invalid data received from getSetting API:", settingsResponse);
        }
      } catch (error) {
        console.error("Error initializing data:", error);
        toast.error("Failed to initialize data");
      } finally {
        setLoader(false);
      }
    };

    initializeData();
  }, [form]);

  const addNewOffice = async (values) => {
    try {
      const cleanedValues = {
        company_name: values.company_name || '',
        tag_line: values.tag_line || null,
        address: values.address || '',
        // In addNewOffice function, ensure the phone cleaning is consistent
        phone: (values.phone || ''), // Remove any existing +44 prefix
        email: values.email || '',
        website: values.website || '',
        footer: values.footer || '',
        officeTypeId: values.officeTypeId || null,
        gst: values.gst || null
      };

      const response = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `setting/addOffice`,
        data: cleanedValues,
      });

      if (response.status === 200 || response.status === 201) {
        await fetchSettings();
        // handleRefresh();
        onUpdate();
        return "success";
      }
      throw new Error("Failed to add office");
    } catch (error) {
      console.error("Error in addNewOffice:", error);
      throw error;
    }
  };

  const updateInvoice = async (values) => {
    try {
      if (!Array.isArray(initValues)) {
        throw new Error("Initial values not properly loaded");
      }

      const selectedcompanyId = initValues.find(
        (setting) => setting.company_name === values.selectedOffice
      )?.id;

      if (!selectedcompanyId) {
        throw new Error("Selected office not found");
      }

      const response = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `setting/${selectedcompanyId}`,
        data: {
          ...values,
          officeTypeId: values.officeTypeId
        },
      });

      if (response.status === 200 || response.status === 201) {
        await fetchSettings(); // Refresh settings after updating
        // handleRefresh();
        onUpdate();
        return "success";
      }
      throw new Error("Failed to update office");
    } catch (error) {
      console.error("Error in updateInvoice:", error);
      throw error;
    }
  };

  const onClickLoading = async (values, addNewOfficeFlag) => {
    setLoader(true);
    try {
      const formValues = form.getFieldsValue(true);
      const resp = await (addNewOfficeFlag
        ? addNewOffice(formValues)
        : updateInvoice(formValues));

      if (resp === "success") {
        toast.success(
          addNewOfficeFlag
            ? "New Office Added Successfully"
            : "Office Details Updated Successfully"
        );

        if (addNewOfficeFlag) {
          form.resetFields();
          setIsAddingNewOffice(false);
          setSelectedOfficeType(null); // Reset for new office
        } else {
          // After update, sync selectedOfficeType with the form's latest officeTypeId
          await fetchSettings(); // Refresh data first
          const updatedOfficeTypeId = form.getFieldValue("officeTypeId");
          setSelectedOfficeType(updatedOfficeTypeId);
          // console.log("Post-update selectedOfficeType:", updatedOfficeTypeId);
        }
      }
    } catch (error) {
      console.error("Error in onClickLoading:", error);
      toast.error(error.message || "Failed to add/update office");
    } finally {
      setLoader(false);
    }
  };

  // API call to post the new office type
  const addNewOfficeType = async (values) => {
    try {
      const response = await axios.post('setting/addOfficeType', {
        officeType: values.officeType,
        company_id: client_Id,
        status: true
      });

      if (response.data.success) {
        toast.success('Office Type added successfully!');
        setIsModalVisible(false);
      } else {
        toast.error({ message: 'Failed to add Office Type' });
      }
    } catch (error) {
      // toast.error({ message: 'Error adding Office Type', description: error.message });
    }
  };

  const handleOk = async () => {
    try {
      const values = await modalForm.validateFields();

      // Log the values being sent
      // console.log("Sending office type values:", {
      //   officeType: values.officeType,
      //   company_id: client_Id,
      //   status: true
      // });

      const response = await axios.post('setting/addOfficeType', {
        officeType: values.officeType,
        company_id: client_Id,
        status: true
      });

      // console.log("Add Office Type Response:", response);

      // Check response more comprehensively
      if (response.data && (response.data.success || response.status === 200 || response.status === 201)) {
        // Fetch updated office types
        const typesResponse = await axios.get("setting/getOfficeTypes");

        // console.log("Fetched Office Types:", typesResponse.data);

        if (typesResponse?.data?.length) {
          setCompanyTypes(typesResponse.data);
        }

        toast.success('Office Type added successfully!');
        setIsModalVisible(false);
        modalForm.resetFields(); // Clear the modal form
      } else {
        // More detailed error logging
        console.error("Failed to add office type. Response:", response);
        toast.error(response.data.message || 'Failed to add Office Type');
      }
    } catch (error) {
      // Comprehensive error handling
      console.error("Full error when adding office type:", error);

      // Check if it's an axios error with response
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);

        toast.error(
          error.response.data.message ||
          `Failed to add Office Type. Status: ${error.response.status}`
        );
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        toast.error('No response from server. Please check your connection.');
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error setting up request:", error.message);
        toast.error(`Error: ${error.message}`);
      }
    }
  };

  useEffect(() => {
    fetchSettings()
  }, [])

  useEffect(() => {
    setLoader(true);
    axios
      .get("setting/getOfficeTypes")
      .then((response) => {
        if (response?.data?.length) {
          // console.log("lala", response.data);

          setCompanyTypes(response.data);
        } else {
          console.error("Invalid data received from getOfficeTypes API:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching office types:", error);
      })
      .finally(() => {
        setLoader(false);
      });

    getSetting()
      .then((response) => {
        if (response?.result?.length) {
          // const officeNamesArray = response.result
          //   ?.map((setting) => setting.company_name || "")
          //   .filter(Boolean);
          const officeNamesArray = response.result
            .filter(item => String(item.id) === String(companyId))
            .map(item => item.company_name)
            .filter(Boolean);
          setInitValues(response.result);
          setOfficeNames(officeNamesArray);

          // Set the default office and its details
          const defaultOffice = officeNamesArray[0];
          const defaultOfficeDetails = response.result?.find(
            (setting) => setting.company_name === defaultOffice
          ) || {};

          if (defaultOfficeDetails) {
            form.setFieldsValue({
              selectedOffice: defaultOffice || "",
              ...defaultOfficeDetails
            });
          }
        } else {
          console.error("Invalid data received from getSetting API:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching settings:", error);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [form]);


  const handleOfficeChange = (selectedOffice) => {
    // console.log("Selected office changed to:", selectedOffice);
    if (selectedOffice === "addNew") {
      setIsAddingNewOffice(true);
      setSelectedOfficeType(null);
      form.resetFields();
      form.setFieldsValue({ selectedOffice: "addNew" });
    } else {
      setIsAddingNewOffice(false);
      if (Array.isArray(initValues)) {
        const selectedSetting = initValues.find(
          (setting) => setting.company_name === selectedOffice
        );
        // console.log("Selected setting:", selectedSetting);
        if (selectedSetting) {
          const formValues = {
            ...selectedSetting,
            selectedOffice,
            officeTypeId: selectedSetting.officeTypeId || null,
            phone: selectedSetting.phone?.replace("+44", "") || "",
          };
          // console.log("Setting form values on office change:", formValues);
          form.setFieldsValue(formValues);
          setSelectedOfficeType(selectedSetting.officeTypeId || null);
        }
      }
    }
  };

  // const handleOfficeChange = (selectedOffice) => {
  //   console.log("Selected office:", selectedOffice); // Debug log

  //   if (selectedOffice === "addNew") {
  //     setIsAddingNewOffice(true);
  //     setSelectedOfficeType(null);
  //     form.resetFields();
  //     form.setFieldsValue({ selectedOffice: "addNew" });
  //   } else {
  //     setIsAddingNewOffice(false);

  //     if (Array.isArray(initValues)) {
  //       const selectedSetting = initValues.find(
  //         (setting) => setting.company_name === selectedOffice
  //       );

  //       console.log("Selected setting:", selectedSetting); // Debug log

  //       if (selectedSetting) {
  //         console.log("Setting office type ID:", selectedSetting.officeTypeId); // Debug log
  //         setSelectedOfficeType(selectedSetting.officeTypeId);

  //         // Prepare form values
  //         const formValues = {
  //           ...selectedSetting,
  //           selectedOffice,
  //           officeTypeId: selectedSetting.officeTypeId,
  //           phone: selectedSetting.phone?.replace('+44', '')
  //         };

  //         console.log("Setting form values:", formValues);
  //         form.setFieldsValue(formValues);
  //       }
  //     }
  //   }
  // };



  return (
    <Fragment>
      <UserPrivateComponent permission={"create-setting"}>
        <Row className="mr-top" justify="center">
          <Col
          // xs={24}
          // sm={24}
          // md={24}
          // lg={11}
          // xl={11}
          // className="border rounded column-design"
          >
            {/* <Card bordered={false}> */}
            {/* <Title level={4} className="m- mb-4 text-center">
                Company Setting
              </Title> */}
            {loader ? (<Loader />) :
              initValues ? (
                <Form
                  initialValues={{
                    ...initValues,
                  }}
                  form={form}
                  name="basic"
                  labelCol={{
                    span: 7,
                  }}
                  labelWrap
                  wrapperCol={{
                    span: 16,
                  }}
                  // onFinish={onFinish}
                  // onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  {/* Dropdown for selecting the office name */}
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Select Office"
                    name="selectedOffice"
                  >
                    <Select
                      onChange={(selectedOffice) =>
                        handleOfficeChange(selectedOffice)
                      }
                    >
                      <Option value="addNew">Add New Office</Option>
                      {officeNames.map((officeName) => (
                        <Option key={officeName} value={officeName}>
                          {officeName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    fields={[{ name: "Company Name" }]}
                    label="Company Name"
                    name="company_name"
                    rules={[
                      {
                        required: true,
                        message: "Please input Company name!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Office Type"
                    name="officeTypeId"
                    rules={[
                      {
                        required: false,
                        message: "Please select Office Type!",
                      },
                    ]}
                  >
                    <Row justify="space-between" align="middle">
                      <Col span={20}>
                        <Select
                          placeholder="Select Office Type"
                          value={selectedOfficeType} // Controlled by state
                          onChange={(value) => {
                            // console.log("Office Type changed to:", value);
                            setSelectedOfficeType(value);
                            form.setFieldsValue({ officeTypeId: value });
                          }}
                        >
                          {companyTypes.map((type) => (
                            <Option key={type.id} value={type.id}>
                              {type.officeType}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                      <Col span={4} style={{ textAlign: "right" }}>
                        <Button type="primary" onClick={showModal}>
                          +
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item>
                  {/* <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Office Type"
                    name="officeTypeId"
                    rules={[
                      {
                        required: false,
                        message: "Please select Office Type!",
                      },
                    ]}
                  >
                    <Row justify="space-between" align="middle">
                      <Col span={20}>
                        
                        <Select
                          placeholder="Select Office Type"
                          value={selectedOfficeType}
                          onChange={(value) => {
                            setSelectedOfficeType(value);
                            form.setFieldsValue({ officeTypeId: value });
                          }}
                        >
                          {companyTypes.map((type) => (
                            <Option key={type.id} value={type.id}>
                              {type.officeType}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                      <Col span={4} style={{ textAlign: "right" }}>
                        <Button type="primary" onClick={showModal}>
                          +
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item> */}



                  {/* <Form.Item
                    style={{ marginBottom: "10px" }}
                    fields={[{ name: "Tagline" }]}
                    label="Tagline"
                    name="tag_line"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Please input Tagline!",
                    //   },
                    // ]}
                  >
                    <Input />
                  </Form.Item> */}

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Address"
                    name="address"
                    rules={[
                      {
                        required: false,
                        message: "Please input Address!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Phone Number"
                    name="phone"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please input Phone Number!",
                  //   },
                  //   {
                  //     pattern: /^[0-9]{10}$/,
                  //     message: "Please enter a valid 10-digit phone number!",
                  //   },
                  // ]}
                  >
                    <Input placeholder="Phone" maxLength={10} addonBefore="+44" />
                  </Form.Item>

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Email Address"
                    name="email"
                    rules={[
                      // {
                      //   required: true,
                      //   message: "Please input Email Address!",
                      // },
                      { type: "email", message: "Please enter a valid email!" }
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    style={{ marginBottom: "10px" }}
                    label="Website"
                    name="website"
                    rules={[
                      // {
                      //   required: true,
                      //   message: "Please input Website!",
                      // },
                      { type: "url", message: "Please enter a valid URL!" }
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  {/* <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Footer"
                      name="footer"
                      rules={[
                        {
                          required: true,
                          message: "Please input Footer!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item> */}

                  <Form.Item className={styles.addBtnContainer}>
                    {isAddingNewOffice ? (
                      <Button
                        type="primary"
                        shape="round"
                        size="large"
                        loading={loader}
                        onClick={() => onClickLoading(form.getFieldsValue(), true)}
                      >
                        Add New Office
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        shape="round"
                        size="large"
                        loading={loader}
                        onClick={() => onClickLoading(form.getFieldsValue(), false, initValues)}
                      >
                        Update Office Details
                      </Button>
                    )}
                  </Form.Item>

                </Form>
              ) : (
                <Loader />
              )}
            {/* </Card> */}
          </Col>
        </Row>
        {/* Modal for adding a new office type */}
        {/* <SettingsTablePage /> */}
        <Modal
          title="Add Office Type"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Form form={modalForm} layout="vertical">
            <Form.Item
              label="Office Type"
              name="officeType"
              rules={[{ required: true, message: "Please input office type!" }]}
            >
              <Input />
            </Form.Item>
          </Form>
        </Modal>
      </UserPrivateComponent>

    </Fragment>

  );
};

export default AddDetails;
